export const ApiUrls = {
  Admin: {
    ADD_BUSINESS: 'admin/business/create-with-user',
    GET_BUSINESSES: 'admin/business',
    SEARCH_BUSINESSES: 'admin/business/search',
    GET_BUSINESS_DETAIL: 'admin/business/',
    UPDATE_BUSINESS: 'admin/business/',
    GET_PROFILE: 'admin/profile',
    GET_TEAM_LIST: 'admin/{businessId}/list',
    INVITE_TEAM: 'admin/{businessId}/invite',
    RESEND_INVITATION: 'admin/{businessId}/resend-invite',
    PASSWORD_RESET: 'admin/users/{userId}/password-reset',
    MFA_RESET: 'admin/users/{userId}/mfa/reset',
    DELETE_USER: 'admin/{businessId}/users/{userId}',
    GET_BUSINESS_LIST: 'admin/business/basic',
    GET_VETTING_LOGS: 'admin/vetting/logs/{businessId}',
    POST_PROGRAM: 'admin/program',
    UPDATE_PROGRAM: 'admin/program',
    ADD_PHONE_NUMBER: 'admin/phone',
    GET_PHONE_NUMBER_LIST: 'admin/phone/{programId}',
    GET_NETWORK_STATUS: 'admin/program-network-distribution/{programId}',
    GET_PROGRAM_SEARCH: 'admin/program/search/{businessId}',
    GET_PHONE_NUMBER_SEARCH: 'admin/program/{programId}/numbers/search',
    DELETE_PHONE_NUMBER: 'admin/phone',
    GET_PHONE_DETAIL: 'admin/phone/detail/{phoneNumberGuid}',
    SYNC_PHONE_NETWORK: 'admin/phone/{phoneNumberGuid}/sync/{networkDistributionId}',
    DELETE_PROGRAM: 'admin/program/{programId}',
    GET_ACTIVITIES: 'admin/activities/{businessId}',
    GET_BUSINESS_BY_ID: 'admin/business/{businessId}',
    TOGGLE_BUSINESS_ANTI_SPOOFING: 'admin/business/{businessId}/anti-spoofing',
    GET_ADMIN_PROGRAM_LIST: 'admin/program/list/{businessId}',
    /* Vetting status for Business */
    POST_VETTING_STATUS: 'admin/vetting/business/status',
    /* send to identify */
    POST_VETTING_IDENTITY: 'admin/vetting/create/{{businessId}}',

    //signle business dasboard
    GET_SINGLE_BUSINESS_DASHBOARD: 'admin/dashboard/metrics/{businessId}',

    //get multibusiness dasboard
    GET_MULTI_BUSINESS_DASHBOARD: 'admin/dashboard/metrics',
  
    /* network distrubutation */
    GET_NETWORK_STATUS_ADMIN: 'admin/program-network-distribution/{programId}',
    GET_NETWORK_DISTRIBUTION: 'admin/business/{businessId}/network-distribution',
    POST_NETWORK_DISTRIBUTION: 'admin/business/{businessId}/network-distribution/assign',
    
    /* Dashboard APIs */
    GET_BUSINESSES_NAME: 'admin/dashboard/businesses',
    GET_BRANDED_CALLS: 'admin/dashboard/branded-calls/',
    GET_PHONE_NUMBERS: 'admin/dashboard/phone-numbers/',
    GET_SUMMARY: 'admin/dashboard/billing-summary/',
    GET_AVG_CALL_DURATION: 'admin/dashboard/call-duration/',
    GET_UNDERPROCESS_BUSINESS: 'admin/dashboard/business-under-process',
    TOP_5_DISPLAY: 'admin/dashboard/display-names/',
    /* Dashboard APIs - close */
    /* Reports APIs */
    GET_CARRIER_VOLUMES_BY_BUSINESS: 'admin/billing/billable-calls/by-business-name-and-source',
    GET_BILLABLE_CALLS_BY_SOURCE: 'admin/billing/billable-calls/by-source',
    GET_MONTHLY_VOLUMES_BY_SOURCE: 'admin/billing/billable-calls/last-6-months-by-source',
    GET_ANSWER_RATES: 'admin/report/answer-rate/',
    GET_BRANDED_CALLS_REPORT: 'admin/report/branded-calls/',
    GET_PHONE_NUMBERS_REPORT: 'admin/report/phone-numbers/',
    GET_BILLABLE_CALLS_REPORT: 'admin/report/billable-calls-performance/',
    ALL_DISPLAY_NAMES: 'admin/report/all-display-names/',
    DOWNLOAD_REPORT: 'admin/report/download-reports/',
    GET_AVERAGE_CALL_DURATION: 'admin/report/avg-call-duration/',
    GET_BRANDED_CALLS_BILLING: 'admin/billing/branded-calls',
    GET_BRANDED_CALLS_BY_DISPLAY_NAME_BILLING: 'admin/billing/branded-calls/by-display-name',
    GET_DAILY_DETAILS_BILLING: 'admin/billing/daily-details',
    GET_DAILY_DETAILS_BILLING_CSV: 'admin/billing/daily-details/csv',
    GET_PHONE_NUMBERS_BILLING: 'admin/billing/phone-numbers',
    GET_CALL_DURATION_BUCKETS_BILLING: 'admin/billing/call-duration-buckets',
    /* Self-Serve reporting — Monthly Self-Serve Revenue */
    GET_SELF_SERVE_REVENUE_SUMMARY: 'admin/self-serve/reporting/revenue/summary',
    GET_SELF_SERVE_REVENUE_MONTHLY: 'admin/self-serve/reporting/revenue/monthly',
    GET_SELF_SERVE_BUSINESS_COUNT: 'admin/self-serve/reporting/businesses/count',
    GET_SELF_SERVE_SUBSCRIPTION_HEALTH: 'admin/self-serve/reporting/subscriptions/health',
    GET_SELF_SERVE_BRANDED_CALL_VOLUME: 'admin/self-serve/reporting/branded-calls/volume',
    /* Self-Serve — admin subscriptions/cancellations/suspensions queues + per-business Stripe invoices */
    GET_SELF_SERVE_SUBSCRIPTIONS: 'admin/self-serve/subscriptions',
    GET_SELF_SERVE_CANCELLATIONS: 'admin/self-serve/cancellations',
    GET_SELF_SERVE_SUSPENSIONS: 'admin/self-serve/suspensions',
    GET_SELF_SERVE_RENEWALS: 'admin/self-serve/renewals',
    GET_SELF_SERVE_STRIPE_INVOICES: 'admin/self-serve/business/',
    TERMINATE_BUSINESS: 'admin/self-serve/business/{businessId}/terminate',
    /* Sales Talk — admin visibility for public "Talk to Sales" leads */
    GET_SALES_CONTACTS: 'admin/sales-contacts',
    GET_SALES_CONTACT_DETAIL: 'admin/sales-contacts/',
    ADD_SALES_CONTACT_NOTE: 'admin/sales-contacts/{id}/notes',
    REJECT_SALES_CONTACT: 'admin/sales-contacts/{id}/reject',
    CONVERT_SALES_CONTACT: 'admin/sales-contacts/{id}/convert',
    GET_AVERAGE_CALL_DURATION_BILLING: 'admin/billing/average-call-duration',
    GET_ANSWER_RATE_BILLING: 'admin/billing/answer-rate',
    /* Reports APIs - close */
    GET_PHONE: 'admin/phone',
    POST_PHONE: 'admin/phone/',
    GET_PHONE_LIST_BY_PROGRAM: 'admin/phone/{programId}',
    POST_BUSINESS: 'admin/support/business-user',
    GET_BUSINESS: 'admin/support/business-user/',
    GET_UN_SYNCED_BUSINESSES: 'admin/support/unsynced-businesses',
    POST_UN_SYNCED_BUSINESSES: 'admin/support/unsynced-businesses/import',
    IMPORT_CALL_PERFORMANCE_DATA: 'admin/support/import-data/call-performance',
    IMPORT_GENERIC_DATA: 'support/import-data/generic',
    RESET_USER_PASSWORD: 'admin/support/business-user/reset-password',
    UPDATE_USER: 'admin/business/{businessId}/edit-user/{userId}',
    GET_VETTING_BUSINESS_QUEUE: 'admin/vetting/business/queue',
    SEARCH_VETTING_BUSINESS_QUEUE: 'admin/vetting/business/search',
    GET_PROGRAM_APPROVALS_LIST: 'admin/program/list/{businessId}',
    GET_PROGRAM_LIST: 'admin/program/list',
    GET_PROGRAM_DETAIL: 'admin/program/{programId}',
    CHANGE_PROGRAM_DISPLAY_STATUS: 'admin/program/{programId}/change-display-status',
    GET_PARTNERS: 'admin/partner',
    CREATE_PARTNER: 'admin/partner',
    GET_PARTNER_BUSINESSES: 'admin/partner/{resellerId}/businesses',
    UNASSIGN_PARTNER_BUSINESS: 'admin/partner/{resellerId}/businesses/{businessId}',
    ASSIGN_PARTNER_BUSINESSES: 'admin/partner/{resellerId}/businesses/assign',
    RESEND_PARTNER_INVITE: 'admin/partner/{resellerId}/resend-invite',
    /* Admin Business Manager Management */
    ADMIN_MANAGE_GET_SUB_PARTNERS:    'admin/partner/{resellerId}/manage/users',
    ADMIN_MANAGE_CREATE_SUB_PARTNER:  'admin/partner/{resellerId}/manage/users',
    ADMIN_MANAGE_UPDATE_SUB_PARTNER:  'admin/partner/{resellerId}/manage/users/{userId}',
    ADMIN_MANAGE_DELETE_SUB_PARTNER:  'admin/partner/{resellerId}/manage/users/{userId}',
    ADMIN_MANAGE_RESEND_INVITE:       'admin/partner/{resellerId}/manage/users/{userId}/resend-invite',
    ADMIN_MANAGE_GET_USER_BUSINESSES: 'admin/partner/{resellerId}/manage/users/{userId}/businesses',
    ADMIN_MANAGE_ASSIGN_BUSINESSES:   'admin/partner/{resellerId}/manage/users/{userId}/businesses/assign',
    ADMIN_MANAGE_UNASSIGN_BUSINESS:   'admin/partner/{resellerId}/manage/users/{userId}/businesses/{businessId}',
    ADMIN_MANAGE_GET_DOWNSTREAM_POOL: 'admin/partner/{resellerId}/manage/businesses',
    /* Partner Business Management */
    CREATE_PARTNER_BUSINESS: 'admin/partner-business',
    GET_PARTNER_BUSINESS_LIST: 'admin/partner-business',
    GET_DOWNSTREAM_BUSINESSES: 'admin/partner-business/{businessId}/downstream',
    ASSIGN_DOWNSTREAM_BUSINESSES: 'admin/partner-business/{businessId}/downstream/assign',
    UNASSIGN_DOWNSTREAM_BUSINESS: 'admin/partner-business/{businessId}/downstream/{downstreamBusinessId}',
    GET_ALL_PHONE_NUMBERS: 'admin/phone/{businessId}/phone-numbers',
    DOWNLOAD_PHONE_NUMBERS_CSV: 'admin/phone/{businessId}/phone-numbers/download/csv',
    /* branded calling dashboard API */
     top_Display_Names: 'admin/dashboard/metrics/{businessId}/top-display-names',
     last_period: 'admin/dashboard/metrics/{businessId}/last-period',
     Recent_activity: 'admin/activities/{businessId}',
    /* Support tickets */
    GET_TICKET_NOTIFICATIONS: 'admin/tickets/notifications',
    GET_TICKETS: 'admin/tickets',
    POST_TICKET: 'admin/tickets',
    GET_TICKET_DETAIL: 'admin/tickets/{ticketUuid}',
    POST_TICKET_COMMENT: 'admin/tickets/{ticketUuid}/comments',
    PATCH_TICKET_STATUS: 'admin/tickets/{ticketUuid}/status',
  },
  User: {
    GET_PROFILE: 'user/profile',
    GET_BUSINESS: 'user/business',
    UPDATE_BUSINESS: 'user/business/{businessId}',
    POST_BUSINESS: 'user/business',
    /* Branded Calling APIs */
    GET_PROGRAM_LIST: 'user/program',
    UPDATE_PROGRAM: 'user/program',
    GET_PROGRAM_SEARCH: 'user/program/search/{businessId}',
    DELETE_PROGRAM: 'user/program/{programId}',
    GET_PHONE_NUMBER_LIST: 'user/phone/{programId}',
    GET_PHONE_NUMBER_SEARCH: 'user/program/{programId}/numbers/search',
    DELETE_PHONE_NUMBER: 'user/phone',
    GET_NETWORK_STATUS: 'user/program-network-distribution/{programId}',
    GET_ACTIVITIES: 'user/activities',

    /* Dashboard APIs */
    GET_TEAM_LIST: 'user/{businessId}/list',
    INVITE_TEAM: 'user/{businessId}/invite',
    RESEND_INVITATION: 'user/{businessId}/resend-invite',
    DELETE_USER: 'user/{businessId}/users/{userId}',
    GET_BRANDED_CALLS: 'user/dashboard/branded-calls/',
    GET_PHONE_NUMBERS: 'user/dashboard/phone-numbers/',
    GET_SUMMARY: 'user/dashboard/billing-summary/',
    GET_AVG_CALL_DURATION: 'user/dashboard/call-duration/',
    TOP_5_DISPLAY: 'user/dashboard/display-names/',

    /* branded calling dashboard API */
    top_Display_Names: 'user/dashboard/metrics/{businessId}/top-display-names',
    last_period: 'user/dashboard/metrics/{businessId}/last-period',
    Recent_activity: 'user/activities',

    /* Dashboard APIs - close */
    /* Reports APIs */
    GET_ANSWER_RATES: 'user/report/answer-rate/',
    GET_BRANDED_CALLS_REPORT: 'user/report/branded-calls/',
    GET_PHONE_NUMBERS_REPORT: 'user/report/phone-numbers/',
    GET_BILLABLE_CALLS_REPORT: 'user/report/billable-calls-performance/',
    ALL_DISPLAY_NAMES: 'user/report/all-display-names/',
    DOWNLOAD_REPORT: 'user/report/download-reports/',
    GET_AVERAGE_CALL_DURATION: 'user/report/avg-call-duration/',
    GET_BRANDED_CALLS_BILLING: 'user/billing/branded-calls',
    GET_PHONE_NUMBERS_BILLING: 'user/billing/phone-numbers',
    GET_DAILY_DETAILS_BILLING: 'user/billing/daily-details',
    GET_DAILY_DETAILS_BILLING_CSV: 'user/billing/daily-details/csv',
    GET_BRANDED_CALLS_BY_DISPLAY_NAME_BILLING: 'user/billing/branded-calls/by-display-name',
    GET_CALL_DURATION_BUCKETS_BILLING: 'user/billing/call-duration-buckets',
    GET_AVERAGE_CALL_DURATION_BILLING: 'user/billing/average-call-duration',
    GET_ANSWER_RATE_BILLING: 'user/billing/answer-rate',
    /* Reports APIs - close */

    GET_PHONE: 'user/phone',
    POST_PHONE: 'user/phone',
    PUT_PHONE: 'user/phone/',
    GET_PHONE_ONE: 'user/phone/',
    POST_PROGRAM: 'user/program',
    ADD_PHONE_NUMBER: 'user/phone',
    GET_ALL_PHONE_NUMBERS: 'user/phone/{businessId}/phone-numbers',
    DOWNLOAD_PHONE_NUMBERS_CSV: 'user/phone/{businessId}/phone-numbers/download/csv',
    GET_ADMIN_PROGRAM_LIST: 'user/program',
    GET_PROGRAM_DETAIL: 'user/program/{programId}',

    /* Support tickets */
    GET_TICKET_NOTIFICATIONS: 'user/tickets/notifications',
    GET_TICKETS: 'user/tickets',
    POST_TICKET: 'user/tickets',
    GET_TICKET_DETAIL: 'user/tickets/{ticketUuid}',
    POST_TICKET_COMMENT: 'user/tickets/{ticketUuid}/comments',
  },

  Public: {
    REGISTER: 'register',
    SALES_CONTACT: 'sales-contact',
    GET_REGISTER: 'register/profile/',
    VERIFY_EMAIL: 'register/email-verification',
    GET_COUNTRIES: 'master/country',
    GET_CALL_PURPOSE: 'master/call-purpose',
    GET_INDUSTRY: 'master/industry',
    GET_EMPLOYEE_RANGE: 'master/number-of-employee',
    REGISTER_BUSINESS: 'register/business',
    VERIFY_TOKEN: 'register/verify-token-url',
    RESEND_VERIFICATION_EMAIL: 'register/resend-otp',
    GET_US_STATES: 'master/state/us',
  },

  Partner: {
    GET_PROFILE:                    'partner/profile',
    GET_ME:                         'partner/me',
    GET_BUSINESS_LIST:              'partner/business/basic',
    GET_BUSINESSES:                 'partner/business',
    GET_BUSINESS_DETAIL:            'partner/business/',
    UPDATE_BUSINESS:                'partner/business/',
    ADD_BUSINESS:                   'partner/business/create-with-user',
    GET_TEAM_LIST:                  'partner/{businessId}/list',
    INVITE_TEAM:                    'partner/{businessId}/invite',
    RESEND_INVITATION:              'partner/{businessId}/resend-invite',
    DELETE_USER:                    'partner/{businessId}/users/{userId}',
    POST_PROGRAM:                   'partner/program',
    UPDATE_PROGRAM:                 'partner/program',
    DELETE_PROGRAM:                 'partner/program/{programId}',
    GET_PROGRAM_LIST:               'partner/program/list',
    GET_ADMIN_PROGRAM_LIST:         'partner/program/list/{businessId}',
    GET_PROGRAM_DETAIL:             'partner/program/{programId}',
    GET_PROGRAM_SEARCH:             'partner/program/search/{businessId}',
    ADD_PHONE_NUMBER:               'partner/phone',
    DELETE_PHONE_NUMBER:            'partner/phone',
    GET_PHONE_NUMBER_LIST:          'partner/phone/{programId}',
    GET_PHONE_NUMBER_SEARCH:        'partner/program/{programId}/numbers/search',
    GET_ALL_PHONE_NUMBERS:          'partner/phone/{businessId}/phone-numbers',
    DOWNLOAD_PHONE_NUMBERS_CSV:     'partner/phone/{businessId}/phone-numbers/download/csv',
    GET_ACTIVITIES:                 'partner/activities/{businessId}',
    GET_VETTING_LOGS:               'partner/vetting/logs/{businessId}',
    GET_SINGLE_BUSINESS_DASHBOARD:  'partner/dashboard/metrics/{businessId}',
    GET_MULTI_BUSINESS_DASHBOARD:   'partner/dashboard/metrics',
    GET_NETWORK_STATUS:             'partner/program-network-distribution/{programId}',
    /* Sub-Partner Management */
    GET_SUB_PARTNERS:               'partner/manage/users',
    CREATE_SUB_PARTNER:             'partner/manage/users',
    UPDATE_SUB_PARTNER:             'partner/manage/users/{userId}',
    DELETE_SUB_PARTNER:             'partner/manage/users/{userId}',
    RESEND_SUB_PARTNER_INVITE:      'partner/manage/users/{userId}/resend-invite',
    GET_SUB_PARTNER_BUSINESSES:     'partner/manage/users/{userId}/businesses',
    ASSIGN_SUB_PARTNER_BUSINESSES:  'partner/manage/users/{userId}/businesses/assign',
    UNASSIGN_SUB_PARTNER_BUSINESS:  'partner/manage/users/{userId}/businesses/{businessId}',
    GET_DOWNSTREAM_POOL:            'partner/manage/businesses',
    /* branded calling dashboard API */
    top_Display_Names:              'partner/dashboard/metrics/{businessId}/top-display-names?periodDays=7',
    last_period:                    'partner/dashboard/metrics/{businessId}/last-period?periodDays=28',
    Recent_activity:                'partner/activities/{businessId}',

    /* Billing / Reports APIs */
    GET_BRANDED_CALLS_BILLING:                  'partner/billing/branded-calls',
    GET_PHONE_NUMBERS_BILLING:                  'partner/billing/phone-numbers',
    GET_BRANDED_CALLS_BY_DISPLAY_NAME_BILLING:  'partner/billing/branded-calls/by-display-name',
    GET_DAILY_DETAILS_BILLING:                  'partner/billing/daily-details',
    GET_DAILY_DETAILS_BILLING_CSV:              'partner/billing/daily-details/csv',
    GET_CALL_DURATION_BUCKETS_BILLING:          'partner/billing/call-duration-buckets',
    GET_AVERAGE_CALL_DURATION_BILLING:          'partner/billing/average-call-duration',
    GET_ANSWER_RATE_BILLING:                    'partner/billing/answer-rate',

    /* Support tickets (all require ?businessId= / businessId in body) */
    GET_TICKET_NOTIFICATIONS:                   'partner/tickets/notifications',
    GET_TICKETS:                                'partner/tickets',
    POST_TICKET:                                'partner/tickets',
    GET_TICKET_DETAIL:                          'partner/tickets/{ticketUuid}',
    POST_TICKET_COMMENT:                        'partner/tickets/{ticketUuid}/comments',
  },

  SelfServe: {
    GET_PLANS: 'self-serve/plans',
  },

  Subscription: {
    POST_CHECKOUT:           'user/subscription/checkout',
    POST_VALIDATE_REFERRAL:  'user/subscription/validate-referral',
    POST_CONFIRM:            'user/subscription/confirm',
    POST_TOP_UP:             'user/subscription/top-up',
    GET_SUBSCRIPTION:        'user/subscription',
    GET_PLANS:               'user/subscription/plans',
    GET_TAX_INVOICES:        'user/subscription/tax-invoices',
    TAX_INVOICE_DOWNLOAD:    'user/subscription/tax-invoices/{invoiceId}/download',
    GET_STRIPE_INVOICES:     'user/subscription/stripe-invoices',
    GET_PAYMENT_METHOD:      'user/subscription/payment-method',
    POST_SAVE_PAYMENT_METHOD:'user/subscription/save-payment-method',
    POST_SETUP_INTENT:       'user/subscription/setup-intent',
    GET_RENEWAL_INTENT:      'user/subscription/renewal-payment-intent',
    POST_CONFIRM_RENEWAL:    'user/subscription/confirm-renewal',
    PUT_CANCEL:              'user/subscription/cancel',
    PUT_REACTIVATE:          'user/subscription/reactivate',
    SWITCH:                  'user/subscription/switch',
    SWITCH_PENDING:          'user/subscription/switch/pending',
    SWITCH_CANCEL:           'user/subscription/switch/cancel',
  },

  Lookup: {
    GET_COUNTRIES: 'lookup/countries',
    GET_STATES: 'lookup/countries/{countryCode}/states',
    GET_CALL_PURPOSE: 'lookup/call-purposes',
    GET_INDUSTRY: 'lookup/industry-types',
    GET_EMPLOYEE_RANGE: 'lookup/employee-counts',
  },
};
